import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24e161e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-inner" }
const _hoisted_2 = { class: "select-icon" }
const _hoisted_3 = ["onPointerenter", "onClick"]

import { computed, ref, Ref } from "vue";
import { useI18n } from "vue-i18n";
import Tooltip from "./tooltip/Tooltip.vue";
import MatterDescription from "./tooltip/MatterDescription.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    list: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  list: readonly string[];
}

const { t } = useI18n();



const selectElem: Ref<HTMLElement | null> = ref(null);
const optionElem: Ref<HTMLElement | null> = ref(null);
const selectRect: Ref<DOMRect | null> = ref(null);
const optionRect: Ref<DOMRect | null> = ref(null);
const showOptions = ref(false);
const toggleShowOptions = () => {
  if (!showOptions.value) {
    selectRect.value = selectElem.value?.getBoundingClientRect() ?? null;
    showOptions.value = true;
    window.addEventListener("click", hideOptions);
  } else {
    hideOptions();
  }
};
const hideOptions = (e?: MouseEvent) => {
  if (!e || e.target !== selectElem.value) {
    showOptions.value = false;
    window.removeEventListener("click", hideOptions);
  }
};
const select = (newValue: string) => {
  emit("update:modelValue", newValue);
  showHint.value = false;
};
const optionsX = computed(() => selectRect.value?.x ?? 0);
const optionsY = computed(() =>
  !selectRect.value ? 0 : selectRect.value.y + selectRect.value.height
);
const optionsWidth = computed(() => selectRect.value?.width ?? 0);
const matterName = ref("");
const showHint = ref(false);
let enterTimeoutId: number | null = null;
let leaveTimeoutId: number | null = null;
const pointerenter = (_matterName: string) => {
  if (leaveTimeoutId !== null) {
    clearTimeout(leaveTimeoutId);
    leaveTimeoutId = null;
  }
  if (enterTimeoutId !== null) {
    clearTimeout(enterTimeoutId);
  }
  enterTimeoutId = setTimeout(() => {
    enterTimeoutId = null;
    optionRect.value = optionElem.value?.getBoundingClientRect() ?? null;
    showHint.value = true;
    matterName.value = _matterName;
  }, 100);
};
const pointerleave = () => {
  if (enterTimeoutId !== null) {
    clearTimeout(enterTimeoutId);
    enterTimeoutId = null;
  }
  leaveTimeoutId = setTimeout(() => {
    leaveTimeoutId = null;
    showHint.value = false;
  }, 100);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "select",
      ref_key: "selectElem",
      ref: selectElem,
      onClick: toggleShowOptions
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)(__props.modelValue)), 1),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: showOptions.value ? 'caret-up' : 'caret-down'
        }, null, 8, ["icon"])
      ]),
      (showOptions.value)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: ".app"
          }, [
            _createElementVNode("ul", {
              class: "options",
              style: _normalizeStyle({
          top: `${_unref(optionsY)}px`,
          left: `${_unref(optionsX)}px`,
          minWidth: `${_unref(optionsWidth)}px`,
        }),
              ref_key: "optionElem",
              ref: optionElem
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  onPointerenter: ($event: any) => (pointerenter(item)),
                  onPointerleave: pointerleave,
                  onClick: ($event: any) => (select(item))
                }, _toDisplayString(_unref(t)(item)), 41, _hoisted_3))
              }), 128))
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ], 512),
    _createVNode(Tooltip, {
      rect: optionRect.value,
      show: showHint.value,
      "show-to-side": "",
      width: 150,
      height: 150
    }, {
      default: _withCtx(() => [
        _createVNode(MatterDescription, { matterName: matterName.value }, null, 8, ["matterName"])
      ]),
      _: 1
    }, 8, ["rect", "show"])
  ], 64))
}
}

})